<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.mb-5
    .titulo-principal.color-acento-contenido
      .titulo-principal__numero
        span 6
      h1 Conectores de secuencia
    .row.justify-content-center.align-items-center.mb-5
      .col-lg-5
        img.img-a.img-t(data-aos="zoom-in")(src='@/assets/curso/temas/img93.png', alt='')
      .col-lg-7
        p(data-aos="fade-down") Básicamente, los conectores de secuencia son elementos que tiene la lengua para vincular dos o más ideas. De esta manera, al vincular o unir ideas, se pueden formar oraciones complejas, que van a evidenciar un nivel más avanzado de dominio del idioma, lo cual va a permitir que la persona sea competente para expresar sus ideas con eficiencia, con fluidez, tanto en forma escrita como en forma oral.
        .bg30.p-3(data-aos="flip-down")
          p(data-aos="fade-down").mb-0 En general, existe una gran diversidad de conectores, por ello, son muchas las formas que se pueden utilizar para vincular o relacionar las ideas que se quieren expresar. En este sentido, se pueden unir dos o más oraciones para complementarse, contradecirse, plantear una causa o una conclusión, entre otras funciones que se quieran expresar en un momento dado. 

    Separador 
    #t_6_1.titulo-segundo.color-acento-contenido(data-aos="zoom-in-left")
      h2 6.1  Reglas a cumplir con los conectores de secuencia

    .tarjeta.position-relative.rounded-0.bg1.p-3
      .row.justify-content-center.align-items-center
        .col-lg-2.col-5.mb-lg-0.mb-3
          .imagen-absolute
            img(data-aos='zoom-in-up')(src='@/assets/curso/temas/img94.png', alt='')
        .col-lg-10
          p(data-aos="fade-down").mb-0.p-2 Cabe destacar que los conectores de secuencia son muy importantes cuando se participa en un contexto académico, científico, o laboral. Además, también son utilizados en entornos informales, mediante lo cual la persona demuestra fluidez y dominio del idioma, pues, al utilizarlos para expresar sus ideas, se denota consistencia y coherencia en su discurso lingüístico, ya sea en forma oral o escrita. 

    p(data-aos="fade-down").text-center.my-5 De acuerdo con lo anterior, se encuentran conectores:
    .row.justify-content-center.align-items-center.mb-5
      .col-lg-7 
        AcordionA(tipo="a" clase-tarjeta="tarjeta tarjeta--azul")(data-aos="fade-left")
          .row.justify-content-center.align-items-center(titulo="En cuanto a su posición")
            .col-11.bgwhite.p-4
              p Con respecto a su posición en una oración, los conectores gramaticales pueden estar al inicio de la oración, al final o entre las dos ideas que se quiere unir. De manera que la decisión sobre el lugar que ocupa el conector en la oración va a depender del estilo de quien escribe. No obstante, hay algunos conectores que, por sus características, se recomienda que vayan siempre en un lugar determinado en la oración o frase; por ejemplo, cuando se hace una lista (#[i first, second], entre otros), es recomendable colocar el conector al inicio de cada oración.  
          .row.justify-content-center.align-items-center(titulo="Respecto a sustantivos y verbos")
            .col-11.bgwhite.p-4
              p Generalmente, después de un conector, se ubica un sustantivo o un verbo en gerundio.
          .row.justify-content-center.align-items-center(titulo="En atención a la congruencia")
            .col-11.bgwhite.p-4
              p Es sumamente importante que se utilicen conectores adecuados al tipo de texto que se está escribiendo, para que la idea que se quiere expresar sea entendible y pueda ser captada con claridad por la persona que escucha o lee el mensaje dado. Por ejemplo, si se envía un mensaje por WhatsApp a un amigo, se pueden usar conectores informales, pero si se está escribiendo un informe o un artículo para revista científica, se deben utilizar conectores formales.                          
      .col-lg-5
        img.img-a.img-t(data-aos="zoom-in")(src='@/assets/curso/temas/img95.png', alt='') 

    Separador 
    #t_6_2.titulo-segundo.color-acento-contenido(data-aos="zoom-in-left")
      h2 6.2   Tipos de conectores 

    .row.justify-content-center.align-items-center.mb-5
      .col-lg-4
        img.img-a.img-t(data-aos="zoom-in")(src='@/assets/curso/temas/img96.png', alt='')
      .col-lg-8
        .bg16.p-3.mb-4
          p(data-aos="fade-down").mb-0 Existe una gran variedad de conectores que sirven para unir las ideas que se quiere expresar en un momento dado, y debido a que hay gran variedad de ideas, también se pueden usar gran variedad de conectores, dependiendo del mensaje que se quiere hacer llegar, ya sea en forma escrita u oral. Entre ellos están: 
        p(data-aos="fade-down") Conectores de adición, adversativos, causales, comparativos, concesivos, conclusivos, condicionales, continuativos, copulativos, disyuntivos, funcionales, secuenciales, para dar ejemplos, para generalizar, para clarificar, para enfatizar, para concluir, para declarar certezas, positivos y negativos. A continuación, se presenta la descripción de cada uno de ellos:

    .tarjeta.color-acento-botones.p-4.p-md-5.mb-5
      .row.justify-content-around.align-items-center
        .col-8.col-sm-6.col-md-4.mb-4.mb-md-0
          img(src="@/assets/curso/temas/img97.svg")

        .col-md.col-lg-6
          .titulo-segundo.color-acento-contenido
            h3 Conectores
          p.mb-4 En el siguiente documento, se encuentran los tipos de conectores. Es ideal que realice la validación y practique con ejercicios de escritura, redactando cartas, correo y mensajes en inglés.
          
          a.boton.color-acento-botones(:href="obtenerLink('/downloads/Conectores.pdf')" target="_blank" type="application/pdf")
            span Descargar
            i.fas.fa-file-download

    p(data-aos="fade-down").text-center.mb-5 A partir del documento anterior, se presentan ejemplos de algunos de los conectores: 

    .bg31.p-2.mb-5(data-aos="flip-down")
      p(data-aos="fade-down").mb-0.text-white.text-center #[b First part]

    .row.justify-content-center.align-items-center.mb-5
      .col-lg-7(data-aos="fade-right")
        LineaTiempoD.color-primario
          .row.justify-content-center.align-items-center(numero="1" titulo="Conectores de adición")
            .col-11
              p Algunos ejemplos del uso de estos 
                span.pur #[b conectores de adición ] 
                span son:      
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="The baby was crying, then her mom arrived. "
                :audio="require('@/assets/curso/audio/6/19.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 El bebé estaba llorando, después llegó su mamá.
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="Phil Collins plays the piano as well as the guitar."
                :audio="require('@/assets/curso/audio/6/20.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Phil Collins toca el piano, además de la guitarra.
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="If it rains, then we can’t go to school."
                :audio="require('@/assets/curso/audio/6/21.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Si llueve, entonces no podemos ir a la escuela.                         
          .row.justify-content-center.align-items-center(numero="2" titulo="Conectores copulativos")
            .col-11
              p Algunos ejemplos del uso de estos 
                span.pur #[b conectores copulativos ] 
                span son:      
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="Charles not only hit his brother but also his cousin."
                :audio="require('@/assets/curso/audio/6/22.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Charles no solo le pegó a su hermano sino que también a su primo.
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="In addition to being selfish, that girl is very rude."
                :audio="require('@/assets/curso/audio/6/23.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Además de egoísta, esa chica es muy grosera.       
          .row.justify-content-center.align-items-center(numero="3" titulo="Conectores disyuntivos")
            .col-11
              p Algunos ejemplos del uso de estos 
                span.pur #[b conectores disyuntivos ] 
                span son:      
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="Marly is allowed to go to the movies or to the disco."
                :audio="require('@/assets/curso/audio/6/24.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Marly tiene permiso para ir al cine o a la discoteca.
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="Neither your dog nor her cat must eat that food."
                :audio="require('@/assets/curso/audio/6/25.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Ni tu perro ni el gato de ella deben comer esa comida.          
          .row.justify-content-center.align-items-center(numero="4" titulo="Conectores funcionales")
            .col-11
              p Algunos ejemplos del uso de estos 
                span.pur #[b conectores funcionales ] 
                span son:      
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="In order to lose weight, she is on a strict diet."
                :audio="require('@/assets/curso/audio/6/26.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Para adelgazar, ella sigue una dieta estricta.
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="He helped to paint the wall so as to they finish early."
                :audio="require('@/assets/curso/audio/6/27.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 El ayudó a pintar la pared para que ellos terminaran temprano.
          .row.justify-content-center.align-items-center(numero="5" titulo="Conectores secuenciales")
            .col-11
              p Algunos ejemplos del uso de estos 
                span.pur #[b conectores secuenciales ] 
                span son:      
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="First, you have to fill the bottle; second, place it into the fridge, and then wait to drink cold water."
                :audio="require('@/assets/curso/audio/6/28.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Primero, tienes que llenar la botella; en segundo lugar, meterla en la nevera, y luego esperar para tomar agua fría.
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="Not long ago, that old lady was under that bridge."
                :audio="require('@/assets/curso/audio/6/29.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 No hace mucho, esa anciana estaba debajo de ese puente.

      .col-lg-5
        img.img-a.img-t(data-aos="zoom-in")(src='@/assets/curso/temas/img98.png', alt='')    

    .bg32.p-2.mb-5(data-aos="flip-down")
      p(data-aos="fade-down").mb-0.text-center #[b Second part]

    .row.justify-content-center.align-items-center.mb-5
      .col-lg-5
        img.img-a.img-t(data-aos="zoom-in")(src='@/assets/curso/temas/img99.png', alt='')       
      .col-lg-7(data-aos="fade-left")
        LineaTiempoD.color-primario
          .row.justify-content-center.align-items-center(numero="6" titulo="Conectores adversativos")
            .col-11
              p Algunos ejemplos del uso de estos 
                span.pur #[b conectores adversativos ] 
                span son:      
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="I like this dress, but it is very expensive."
                :audio="require('@/assets/curso/audio/6/30.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Me gusta este vestido, pero es muy caro.
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="She doesn’t have a job. Even so, she goes on vacation."
                :audio="require('@/assets/curso/audio/6/31.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Ella no tiene trabajo. Aún así, se va de vacaciones.
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="Paul wants to go to the cinema, but Helen wants to go dancing."
                :audio="require('@/assets/curso/audio/6/32.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Paul quiere ir al cine, pero Helen quiere ir a bailar.                     
          .row.justify-content-center.align-items-center(numero="7" titulo="Conectores causales")
            .col-11
              p Algunos ejemplos del uso de estos 
                span.pur #[b conectores causales ] 
                span son:      
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="I go to the bookshop in order to get the book."
                :audio="require('@/assets/curso/audio/6/33.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Yo voy a la librería para obtener el libro.
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="Thomas is sick because he was exposed to the virus."
                :audio="require('@/assets/curso/audio/6/43.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Thomas está enfermo porque estuvo expuesto al virus.         
          .row.justify-content-center.align-items-center(numero="8" titulo="Conectores comparativos")
            .col-11
              p Algunos ejemplos del uso de estos 
                span.pur #[b conectores comparativos ] 
                span son:      
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="When I grow up, I want to be as important as you, teacher!"
                :audio="require('@/assets/curso/audio/6/34.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Cuando sea grande, quiero ser tan importante como usted, maestra.
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="I would like to be rich as Bill Gates!"
                :audio="require('@/assets/curso/audio/6/35.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Me gustaría ser rico como Bill Gates.
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="You must stand still as if you were a bronze statue."
                :audio="require('@/assets/curso/audio/6/36.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Debes permanecer inmóvil como si fueras una estatua de bronce.
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="Actually, the red car is not as fast as the blue car."
                :audio="require('@/assets/curso/audio/6/37.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Realmente, el carro rojo no es tan veloz como el carro azul.
          .row.justify-content-center.align-items-center(numero="9" titulo="Conectores concesivos")
            .col-11
              p Algunos ejemplos del uso de estos 
                span.pur #[b conectores concesivos ] 
                span son:      
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="Although I have never driven a car, I can learn now."
                :audio="require('@/assets/curso/audio/6/38.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Aunque nunca he manejado un carro, puedo aprender ahora.
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="Even if you eat very little today, you will not be able to wear that tight dress for the party."
                :audio="require('@/assets/curso/audio/6/39.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Aunque comas muy poquito hoy, no podrás usar ese vestido ajustado para la fiesta.
          .row.justify-content-center.align-items-center(numero="10" titulo="Conectores conclusivos")
            .col-11
              p Algunos ejemplos del uso de estos 
                span.pur #[b conectores conclusivos ] 
                span son:      
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="You are very patient, therefore we chose you to take care of the baby."
                :audio="require('@/assets/curso/audio/6/40.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Tú eres muy paciente, por lo tanto te elegimos a ti para cuidar al bebé.
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="She has trained hard, consequently, she deserves to participate in the competition."
                :audio="require('@/assets/curso/audio/6/41.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Ella ha entrenado duro, en consecuencia, merece participar en la competencia.
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="I have to clean the house, so I can’t go to the gym."
                :audio="require('@/assets/curso/audio/6/42.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Yo tengo que limpiar la casa, entonces no puedo ir al gimnasio.

    .bg31.p-2.mb-5(data-aos="flip-down")
      p(data-aos="fade-down").mb-0.text-white.text-center #[b Third part]

    .row.justify-content-center.align-items-center.mb-5
      .col-lg-7(data-aos="fade-right")
        LineaTiempoD.color-primario
          .row.justify-content-center.align-items-center(numero="11" titulo="Conectores condicionales")
            .col-11
              p Algunos ejemplos del uso de estos 
                span.pur #[b conectores condicionales ] 
                span son:      
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="If you behave well, I will buy you an ice cream."
                :audio="require('@/assets/curso/audio/6/1.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Si te portas bien, te compraré un helado.
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="In case you want to go with me, call me, please."
                :audio="require('@/assets/curso/audio/6/2.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0  En caso de que quieras ir conmigo, llámame, por favor.
          .row.justify-content-center.align-items-center(numero="12" titulo="Conectores continuativos")
            .col-11
              p Algunos ejemplos del uso de estos 
                span.pur #[b conectores continuativos ] 
                span son:      
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="She went to the backyard, then she could see the little bird."
                :audio="require('@/assets/curso/audio/6/3.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Ella fue al patio, entonces pudo ver el pajarito.
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="The teacher gave him a medal in addition to a diploma for good behavior."
                :audio="require('@/assets/curso/audio/6/4.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 El profesor le dio una medalla además de un diploma por buen comportamiento. 
          .row.justify-content-center.align-items-center(numero="13" titulo="Conectores para dar ejemplos")
            .col-11
              p Algunos ejemplos del uso de estos 
                span.pur #[b conectores para dar ejemplos ] 
                span son:      
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="Help that old lady such us you would help your grandmother."
                :audio="require('@/assets/curso/audio/6/5.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Ayuda a esa anciana tal como ayudarías a tu abuela.
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="George looks like a  real cop in that costume."
                :audio="require('@/assets/curso/audio/6/6.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 George luce como un policía de verdad con ese disfraz.
          .row.justify-content-center.align-items-center(numero="14" titulo="Conectores para generalizar")
            .col-11
              p Algunos ejemplos del uso de estos 
                span.pur #[b conectores para generalizar ] 
                span son:      
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="In general, all my sons are very affectionate with me."
                :audio="require('@/assets/curso/audio/6/7.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 En general, todos mis hijos son muy cariñosos conmigo.
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="Mostly, Kelly gets up late."
                :audio="require('@/assets/curso/audio/6/8.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Usualmente, Kelly se levanta tarde.            
          .row.justify-content-center.align-items-center(numero="15" titulo="Conectores para clarificar")
            .col-11
              p Algunos ejemplos del uso de estos 
                span.pur #[b conectores para clarificar ] 
                span son:      
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="She must travel soon, that is to say, she must leave tomorrow."
                :audio="require('@/assets/curso/audio/6/9.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Ella debe viajar pronto, es decir, debe partir mañana mismo.
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="The father talks to his daughter. In other words, he scolded her."
                :audio="require('@/assets/curso/audio/6/10.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 El padre habló con su hija. En otras palabras, él la regañó.
      .col-lg-5
        img.img-a.img-t(data-aos="zoom-in")(src='@/assets/curso/temas/1.png', alt='')    

    .bg32.p-2.mb-5(data-aos="flip-down")
      p(data-aos="fade-down").mb-0.text-center #[b Fourth part]

    .row.justify-content-center.align-items-center.mb-5
      .col-lg-5
        img.img-a.img-t(data-aos="zoom-in")(src='@/assets/curso/temas/2.png', alt='')       
      .col-lg-7(data-aos="fade-left")
        LineaTiempoD.color-primario
          .row.justify-content-center.align-items-center(numero="16" titulo="Conectores para enfatizar")
            .col-11
              p Algunos ejemplos del uso de estos 
                span.pur #[b conectores para enfatizar ] 
                span son:      
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="Obviously, you can do the video with your smartphone."
                :audio="require('@/assets/curso/audio/6/11.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Obviamente, tú puedes hacer el video con tu teléfono inteligente.
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="Definitely, you should participate in the contest."
                :audio="require('@/assets/curso/audio/6/12_1.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Definitivamente, tú debes participar en el concurso.
          .row.justify-content-center.align-items-center(numero="17" titulo="Conectores para concluir")
            .col-11
              p Algunos ejemplos del uso de estos 
                span.pur #[b conectores para concluir ] 
                span son:      
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="You didn’t respect the teachers. In short, you have to leave the school."
                :audio="require('@/assets/curso/audio/6/13.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 No respetaste a los profesores. En resumen, tienes que dejar la escuela.
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="She worked all day, so she is very tired."
                :audio="require('@/assets/curso/audio/6/14.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Ella trabajó todo el día, entonces está muy cansada.
          .row.justify-content-center.align-items-center(numero="18" titulo=" Conectores para declarar certezas")
            .col-11
              p Algunos ejemplos del uso de estos 
                span.pur #[b conectores para declarar ] 
                span son:      
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="Surely, Peter will be here at 8:00 a.m."
                :audio="require('@/assets/curso/audio/6/15.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Seguramente, Peter estará aquí a las 8:00 de la mañana.
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="You are indeed my first formal girlfriend."
                :audio="require('@/assets/curso/audio/6/16.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 En efecto, tú eres mi primera novia formal.
          .row.justify-content-center.align-items-center(numero="19" titulo=" Conectores positivos y negativos")
            .col-11
              p Algunos ejemplos del uso de estos 
                span.pur #[b conectores positivos y negativos ] 
                span son:      
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="Sadly, I couldn’t go to your party."
                :audio="require('@/assets/curso/audio/6/17.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Tristemente, no pude ir a tu fiesta.
              TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="Fortunately, Mary found her husband’s bag."
                :audio="require('@/assets/curso/audio/6/18.mp3')"
                @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )            
              p.mb-0 Afortunadamente, Mary encontró el bolso de su esposo.

</template>

<script>
export default {
  name: 'Tema6',
  data: () => ({
    // variables de vue
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
